// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { loginRequested } from '../../store/auth.actions';
import { selectIsCodeRequired } from '../../store/auth.selectors';
import { Subscription } from 'rxjs';
import { LoginPayload } from '@coa/app/libs/auth/auth-module/models/login-payload';

@Component({
  selector: 'coa-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  isCodeRequired = false;
  private subscription: Subscription;

  constructor(
    private store$: Store,
  ) {
  }

  ngOnInit(): void {
    this.subscription = this.store$.pipe(
      select(selectIsCodeRequired),
    ).subscribe(isCodeRequired => {
      this.isCodeRequired = isCodeRequired;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  login(credentials: LoginPayload): void {
    this.store$.dispatch(loginRequested(credentials));
  }
}
